var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-404"},[_vm._v(" Запрашиваемый ресурс не найден"),_c('br'),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v(" Вернуться на главную ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }